export default __webpack_public_path__ + "static/jayne-75c0fa5d0e4e6d465b10361dbac38698.jpg";